import RobotoRegular from 'assets/fonts/RobotoRegular.woff2';
import RobotoMedium from 'assets/fonts/RobotoMedium.woff2';
import SFProLight from 'assets/fonts/SFProLight.woff2';
import SFProRegular from 'assets/fonts/SFProRegular.woff2';
import SFProSemiBold from 'assets/fonts/SFProSemiBold.woff2';

/* Font Faces
 * Style Linking: https://www.fontspring.com/support/style-linking */

export const HeadStyleMobile = () => {
  return (
    <style>
      {`
        html, body {
          font-size: 14px;
        }

        @font-face {
          font-family: 'SF Pro';
          src: url(${SFProLight}) format('woff2');
          font-weight: 300; /* light */
        }
        @font-face {
          font-family: 'SF Pro';
          src: url(${SFProRegular}) format('woff2');
          font-weight: 400; /* normal */
        }
        @font-face {
          font-family: 'SF Pro';
          src: url(${SFProSemiBold}) format('woff2');
          font-weight: 600; /* "semi-bold" */
        }
        @font-face {
          font-family: 'Roboto';
          src: url(${RobotoRegular}) format('woff2');
          font-weight: 400; /* normal */
        }
        @font-face {
          font-family: 'Roboto';
          src: url(${RobotoMedium}) format('woff2');
          font-weight: 500; /* medium */
        }
      `}
    </style>
  );
};

export default HeadStyleMobile;
